export default "__VITE_ASSET__8e6fEKKn__"